// Helpers compartits de graella de dies (píxels fixos, no percentatges) —
// usats per CronogramaGrid.tsx (una fase/expedient) i GeneralTab.tsx (totes
// les fases, totes les expedients) perquè ambdues vistes mostrin els
// mateixos números de dia, no nomes mesos.
export const toISO = (d: Date): string => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const addDaysISO = (iso: string, n: number): string => { const d = new Date(`${iso}T00:00:00`); d.setDate(d.getDate() + n); return toISO(d); };
export const diffDaysISO = (a: string, b: string): number => Math.round((new Date(`${b}T00:00:00`).getTime() - new Date(`${a}T00:00:00`).getTime()) / 86400000);

export const WEEKS_VISIBLE = 10;
export const VISIBLE_DAYS = WEEKS_VISIBLE * 7;
export const DAY_PX = 26;
export const GRID_WIDTH = VISIBLE_DAYS * DAY_PX;
export const MONTH_LABELS = ['Gen', 'Feb', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Des'];

export function dayBarStyle(start: string, end: string, rangeStart: string): { left: string; width: string } {
  return {
    left: `${diffDaysISO(rangeStart, start) * DAY_PX}px`,
    width: `${Math.max(diffDaysISO(start, end) + 1, 1) * DAY_PX}px`,
  };
}

export function monthGroupsFor(rangeStart: string): { label: string; days: number }[] {
  const groups: { label: string; days: number }[] = [];
  for (let i = 0; i < VISIBLE_DAYS; i++) {
    const d = new Date(`${addDaysISO(rangeStart, i)}T00:00:00`);
    const label = `${MONTH_LABELS[d.getMonth()]} ${d.getFullYear()}`;
    if (groups.length > 0 && groups[groups.length - 1].label === label) groups[groups.length - 1].days += 1;
    else groups.push({ label, days: 1 });
  }
  return groups;
}
